@if(false){
<!-- 🔹 Monthly Report 2 - Maintenance Notice -->
<div class="min-h-[500px] flex items-center justify-center p-6">
  <div class="max-w-2xl w-full">
    <!-- Header Card -->
    <div
      class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/20 dark:border-slate-700/50 text-center">
      <!-- Icon -->
      <div class="mx-auto flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full mb-6">
        <svg class="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>

      <!-- Title -->
      <h1 class="text-3xl font-bold text-slate-900 dark:text-slate-100 mb-3">
        Advanced Monthly Report
      </h1>

      <!-- Subtitle -->
      <p class="text-lg text-slate-600 dark:text-slate-300 mb-6">
        Report generation service is currently down
      </p>

      <!-- Error Message -->
      <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6 mb-6">
        <h3 class="text-xl font-semibold text-red-800 dark:text-red-200 mb-2">
          Report Service Unavailable
        </h3>
        <p class="text-red-700 dark:text-red-300 leading-relaxed">
          We're experiencing technical difficulties with our advanced reporting system. Our engineers are actively
          working on a solution. Please check back in a few minutes or try refreshing the page.
        </p>
      </div>

      <!-- Status Indicators -->
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div class="bg-slate-50 dark:bg-slate-800/50 rounded-lg p-4">
          <div class="flex items-center justify-center mb-2">
            <div class="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
          </div>
          <p class="text-sm font-medium text-slate-700 dark:text-slate-300">Data Service</p>
          <p class="text-xs text-red-600 dark:text-red-400">Offline</p>
        </div>
        <div class="bg-slate-50 dark:bg-slate-800/50 rounded-lg p-4">
          <div class="flex items-center justify-center mb-2">
            <div class="w-3 h-3 bg-yellow-500 rounded-full animate-pulse"></div>
          </div>
          <p class="text-sm font-medium text-slate-700 dark:text-slate-300">Analytics</p>
          <p class="text-xs text-yellow-600 dark:text-yellow-400">Limited</p>
        </div>
        <div class="bg-slate-50 dark:bg-slate-800/50 rounded-lg p-4">
          <div class="flex items-center justify-center mb-2">
            <div class="w-3 h-3 bg-green-500 rounded-full"></div>
          </div>
          <p class="text-sm font-medium text-slate-700 dark:text-slate-300">UI Service</p>
          <p class="text-xs text-green-600 dark:text-green-400">Online</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          class="px-6 py-3 bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
            </path>
          </svg>
          Refresh Page
        </button>
        <button
          class="px-6 py-3 bg-slate-200 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 font-medium rounded-lg transition-colors duration-200 flex items-center justify-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
          Go Back
        </button>
      </div>

      <!-- Additional Info -->
      <div class="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700">
        <p class="text-sm text-slate-500 dark:text-slate-400">
          Issue ID: #{{ issueId }} | Expected Resolution: 15-30 minutes
        </p>
      </div>
    </div>
  </div>
</div>
}

<ng-container>
  <!-- Desktop View — toggled by BreakpointService so the mobile component
       (rendered below) and this desktop tree never both display at once. -->
  <div [class.hidden]="!_breakpointService.isDesktop()">
    @if (!mixedMode()) {
    <ai-headlines class="block mb-4"></ai-headlines>
    }

    <div class="card-bg rounded-xl p-4">

      <!-- 🔹 Header Section — hidden in embedded (`mixedMode`) mode because the
         parent (e.g. My Dashboard) provides its own section title + chrome,
         and the date-picker / Customize Layout actions don't apply when the
         user is just previewing pinned widgets. -->
      @if (!mixedMode()) {
      <div class="flex flex-col lg:flex-row gap-4 items-start lg:items-center rounded-2xl mb-4">
        <div class="flex-1 lg:w-7/12 flex flex-col justify-center">
          <p class="text-2xl font-medium text-[#141437] dark:text-white">Training & Contracts Dashboard</p>
        </div>

        <div class="flex justify-end gap-3 items-center flex-wrap">

          <!-- Date Picker -->
          <div class="flex items-center justify-between relative">
            <app-date-picker (valueChange)="rangeValues($event)" (dateRangeChange)="onDateRangeChange($event)"
              (onApply)="onDateRangeChange($event)" [showComparison]="true" [showGroupBy]="true">
            </app-date-picker>
          </div>

          <!-- Customize Layout Button -->
          <button (click)="openCustomizeLayout()"
            class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="7" x="3" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="14" rx="1" />
              <rect width="7" height="7" x="3" y="14" rx="1" />
            </svg>
            Customize layout
          </button>
        </div>
      </div>
      }


      @if (filteredDashboardCards().length > 0) {
      <!-- Drag-drop on the main dashboard body has been disabled.
           Reordering is now performed exclusively from the Customize Layout popup. -->
      <div class="grid grid-cols-12 gap-4 grid-flow-row-dense mt-4">

        @for (card of filteredDashboardCards(); track trackDashboardCard($index, card)) {
        <div [ngClass]="getSectionColClass(card)"
          class="group relative card-bg rounded-2xl shadow-sm transition-all duration-300 hover:shadow-md hover:border-[#AD46FF]/40 overflow-hidden">

          @if (card.widgetId > 0 && !mixedMode()) {
          <button type="button" (click)="addToCustomDashboard(card); $event.stopPropagation()"
            [disabled]="isAddingToCustomDashboard(card)"
            class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center justify-center h-7 px-1.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap overflow-hidden opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
            [ngClass]="isAddedToCustomDashboard(card)
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
                  : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
            [attr.aria-label]="isAddedToCustomDashboard(card) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
            [title]="isAddedToCustomDashboard(card) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
            @if (isAddingToCustomDashboard(card)) {
            <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[180px] focus-visible:max-w-[180px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">{{ isAddedToCustomDashboard(card) ? 'Removing' : 'Adding' }}&hellip;</span>
            </span>
            } @else if (isAddedToCustomDashboard(card)) {
            <!-- At rest: compact check pill (icon-only). On hover the same
                       pill expands and flips to a remove affordance (minus icon
                       + "Remove from Custom Dashboard") so the toggle action stays
                       discoverable without overlapping the card title at rest. -->
            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M5 12h14" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[200px] focus-visible:max-w-[200px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">Remove from Custom Dashboard</span>
            </span>
            } @else {
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            <span
              class="inline-block max-w-0 group-hover/pin:max-w-[180px] focus-visible:max-w-[180px] overflow-hidden transition-[max-width] duration-300 ease-out">
              <span class="pl-1.5 pr-1">Pin to Custom Dashboard</span>
            </span>
            }
          </button>
          }

          <!-- 🔹 Section Content — rendered by section id -->
          <div class="p-4">
            @switch (card.id) {

            <!-- Stats Overview -->
            @case (SectionId.STATS_OVERVIEW) {
            <div class="grid gap-4 min-h-[80px] relative"
              [ngClass]="card.colSpan === 4 ? ' grid-cols-1 sm:grid-cols-1 xl:gap-3 [@media(max-height:620px)]:gap-2 ' : ' lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 '">
              <app-dashboard-cards *ngFor="let statsCard of businessContractsOverallStats" [data]="statsCard"
                [colSpan]="1" [customClass]="'icon-left'" [showComparisonValue]="true" [showPercentIcon]="false">
              </app-dashboard-cards>
              @if(isSectionLoading('contractsOverall')){
              <div class="min-h-[100px]">
                <app-individual-toaster></app-individual-toaster>
              </div>
              }
            </div>
            }

            <!-- MoM Activity Chart -->
            @case (SectionId.MOM_ACTIVITY) {
            <div *ngTemplateOutlet="infoGraph; context: {
                        $implicit: {
                          data1: businessContractsMomActivityData.contractsCreatedData,
                          data2: businessContractsMomActivityData.previousContractsCreatedData,
                          data3: businessContractsMomActivityData.registeredBusinessData,
                          data4: businessContractsMomActivityData.previousRegisteredBusinessData
                        },
                        sub_title: 'Total Enrolled Businesses and Contract Created (MoM)',
                        showToggleButton: true,
                        chartKey: 'momActivity',
                        loadingKey: 'momActivity',
                        showCircleStrokes: false,
                        height: 450,
                        showYGridLines: false,
                        showXGridLines: true
                      }">
            </div>
            }

            <!-- Training Status -->
            @case (SectionId.TRAINING_STATUS) {
            <div class="flex items-center justify-between mb-3">
              <div class="flex flex-col gap-3">
                <span class="text-lg font-medium text-[#141437] dark:text-white font-['Inter',sans-serif]">
                  Training Status
                </span>
                <span class="dark:text-ink-muted text-[#7D7D93] text-sm">Status breakdown</span>
              </div>
              <div class="flex flex-col gap-2 justify-end">
                <span
                  class="text-lg font-medium text-[#38385B] dark:text-ink-soft font-['Inter',sans-serif]">TOTAL</span>
                <span class="dark:text-white text-center font-medium text-[#141437] text-xl">
                  {{ getTotalCount() }}
                </span>
              </div>
            </div>
            <div class="overflow-y-auto  pt-2 hide-scrollbar">
              <!--  [ngClass]="mixedMode() ? 'h-[420px]' : 'max-h-[300px] mb-6'" -->
              @for (item of businessTrainingStatsData; track $index) {
              <div
                class="flex items-center justify-between border border-[#EAEAEA] dark:border-line p-2 rounded-xl mb-2 hover:-translate-y-[2px] duration-300">
                <div class="flex items-center gap-2">
                  <div [ngClass]="getBgColor($index)" class="h-4 w-4 rounded-full shadow-[0px_0px_10px_-6px_#000000]">
                  </div>
                  <span class="dark:text-ink-soft">{{ item?.status }}</span>
                </div>
                <div [ngClass]="getTextColor($index)"
                  class="flex justify-center items-center font-medium px-4 bg-[#F5F5F5] min-w-12 h-10 rounded-lg dark:bg-surface-3">
                  {{ item?.count }}
                </div>
              </div>
              }
              @if(isSectionLoading('businessTraining')){
              <app-individual-toaster></app-individual-toaster>
              }
            </div>
            }

            <!-- Monthly Activity Analysis Table -->
            @case (SectionId.MONTHLY_ANALYSIS) {
            <div *ngTemplateOutlet="infoTables; context: {
                        $implicit: monthlyActivityAnalysis,
                        sub_title: 'MoM Enrolled Businesses, Contract Created and Activation Rate',
                        key: 'monthlyActivityAnalysis',
                        loadingKey: 'momActivity',
                        isFlexCol: true
                      }">
            </div>
            }

            <!-- Businesses Enrolled Running Total -->
            @case (SectionId.ENROLLED_RUNNING) {
            <div class="relative" *ngTemplateOutlet="infoGraph; context: {
                        $implicit: {
                          data1: businessEnrolledRunningTotalData,
                          data2: previousBusinessEnrolledRunningTotalData
                        },
                        sub_title: 'Businesses Enrolled | Running Total',
                        chartKey: 'enrolledBusinesses',
                        loadingKey: 'enrolledRunning',
                        showCircleStrokesWithStroke: false,
                        showCircleStrokes: true,
                        height: 320,
                        showXGridLines: true,
                        showYGridLines: false
                      }">
            </div>
            }

            <!-- Contracts Created Running Total -->
            @case (SectionId.CONTRACTS_RUNNING) {
            <div class="relative" *ngTemplateOutlet="infoGraph; context: {
                        $implicit: {
                          data1: contractsCreatedRunningTotalData,
                          data2: previousContractsCreatedRunningTotalData
                        },
                        sub_title: 'Contracts Created | Running Total',
                        chartKey: 'enrolledContracts',
                        loadingKey: 'contractsRunning',
                        showCircleStrokesWithStroke: false,
                        showCircleStrokes: true,
                        height: 320,
                        showXGridLines: true,
                        showYGridLines: false
                      }">
            </div>
            }

            }
          </div>
        </div>
        }

      </div>
      }

    </div>
  </div>

  <!-- Mobile Section — extracted into a dedicated component.
       Visibility is driven by BreakpointService.isDesktop() so the desktop
       tree above and this mobile component never both render at once. -->
  <div [class.hidden]="_breakpointService.isDesktop()">
    <app-monthly-report-2-mobile [startDate]="startDate()" [endDate]="endDate()" [mixedMode]="mixedMode()"
      [currentBusinessContractsOverall]="currentBusinessContractsOverall"
      [businessTrainingStatsData]="businessTrainingStatsData" (filterRequested)="openFilterSheet()">
    </app-monthly-report-2-mobile>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       🔹 Customize Layout — Mini-Dashboard Editor
       Inline overlay that visually mirrors the actual dashboard structure.
       Each tile takes the same proportional width as its real-dashboard
       counterpart and supports drag-drop reordering, width resizing, and
       visibility toggling — like a true layout builder.
  ═════════════════════════════════════════════════════════════════════════ -->
  @if (isLayoutEditorOpen()) {
  <!-- z-[10000] sits above the global navbar/sidebar (which use z-[999])
         so the popup never gets clipped by the dashboard header. -->
  <div
    class="fixed inset-0 z-[10000] flex items-start sm:items-center justify-center p-3 pt-20 sm:pt-10 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-y-auto"
    (click)="closeLayoutEditor()">

    <div
      class="layout-editor-popup relative w-full max-w-[1100px] max-h-[calc(100vh-6rem)] sm:max-h-[88vh] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden my-auto"
      (click)="$event.stopPropagation()">

      <!-- ▶ Header -->
      <div
        class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="9" x="3" y="3" rx="1" />
              <rect width="7" height="5" x="14" y="3" rx="1" />
              <rect width="7" height="9" x="14" y="12" rx="1" />
              <rect width="7" height="5" x="3" y="16" rx="1" />
            </svg>
          </div>
          <div class="min-w-0">
            <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
              Customize Layout
            </h2>
            <p class="text-[11px] text-violet-700 dark:text-violet-300">
              <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot; toggle the
              <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2.5 flex-wrap">
          <!-- Auto Adjust Width: expands the smallest card in each row of
                 the preview so any leftover columns are filled (e.g. a row
                 with 6 + 4 grows the col-4 card to col-6 → row sums to 12). -->
          <button type="button" (click)="autoAdjustEditorWidths()" [disabled]="!canAutoAdjustEditorWidths()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
            [ngClass]="canAutoAdjustEditorWidths()
                ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
                : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
            title="Expand the smallest card in each row to fill the leftover columns">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
            Auto Adjust Width
          </button>

          <!-- Visible count chip -->
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            {{ editorVisibleCount() }} / {{ editorItems().length }} visible
          </span>

          <!-- Close -->
          <button type="button" (click)="closeLayoutEditor()"
            class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            title="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- ▶ Layout Preview Area (mini dashboard editor) -->
      <div class="flex-1 overflow-y-auto bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

        <!-- 12-col mini grid -->
        <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onEditorCardDrop($event)"
          class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense">

          @for (item of editorItems(); track trackEditorItem($index, item)) {
          <div cdkDrag cdkDragBoundary=".layout-editor-popup" [cdkDragData]="item" [cdkDragDisabled]="!item.visible"
            [ngClass]="[
                  getEditorColSpanClass(item.colSpan),
                  isTallEditorTile(item) ? 'row-span-2' : '',
                  item.visible
                    ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
                    : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
                ]"
            class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

            <!-- Drop placeholder (highlight slot during drag) -->
            <div *cdkDragPlaceholder [ngClass]="[
                    getEditorColSpanClass(item.colSpan),
                    isTallEditorTile(item) ? 'row-span-2' : ''
                  ]"
              class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
            </div>

            <!-- Tile header: drag handle + title + actions -->
            <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
              <div class="flex items-center gap-1.5 min-w-0">
                <span class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                  title="Drag to reorder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="5" r="1" fill="currentColor" stroke="none" />
                    <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
                    <circle cx="9" cy="19" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="5" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
                    <circle cx="15" cy="19" r="1" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <span class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                  [title]="item.title">
                  {{ item.title }}
                </span>
              </div>

              <!-- Visibility toggle -->
              <button type="button" (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
                class="p-1 rounded-md transition-colors shrink-0"
                [ngClass]="item.visible
                      ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                      : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
                [title]="item.visible ? 'Hide section' : 'Show section'">
                @if (item.visible) {
                <app-icon-v2 name="eye" [size]="14"></app-icon-v2>
                } @else {
                <app-icon-v2 name="eye-off" [size]="14"></app-icon-v2>
                }
              </button>
            </div>

            <!-- Tile body: scaled-down preview placeholder + width stepper -->
            <div class="px-2.5 pb-2">
              <div
                class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
                <!-- abstract preview bars -->
                <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                  <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                  <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                  <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                  <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                  <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                  <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
                </div>
                <span
                  class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                  {{ item.colSpan }}/12
                </span>
              </div>

              <!-- Width stepper: minimize-2 / label / maximize-2 -->
              <div class="flex items-center gap-1.5">
                <span
                  class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

                <!-- Decrease (minimize-2) -->
                <button type="button" (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canDecreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canDecreaseEditorCardColSpan(item)
                        ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Decrease width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="4 14 10 14 10 20" />
                    <polyline points="20 10 14 10 14 4" />
                    <line x1="14" y1="10" x2="21" y2="3" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>

                <!-- Current width pill — Small / Medium / Large / Full -->
                <span
                  class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                  {{ getEditorColSpanLabel(item.colSpan) }}
                </span>

                <!-- Increase (maximize-2) -->
                <button type="button" (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canIncreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canIncreaseEditorCardColSpan(item)
                        ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Increase width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 3 21 3 21 9" />
                    <polyline points="9 21 3 21 3 15" />
                    <line x1="21" y1="3" x2="14" y2="10" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          }
        </div>

        @if (editorItems().length === 0) {
        <div class="text-center py-16 text-slate-500 dark:text-slate-400">
          <p class="text-sm">No layout items to customize.</p>
        </div>
        }
      </div>

      <!-- ▶ Footer -->
      <div
        class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
        <button type="button" (click)="resetLayoutEditorToDefaults()"
          class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
          Set Default
        </button>

        <div class="flex items-center gap-2">
          <button type="button" (click)="closeLayoutEditor()"
            class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
            Cancel
          </button>
          <button type="button" (click)="applyLayoutEditor()" [disabled]="editorVisibleCount() === 0"
            class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</ng-container>


<!-- 🔹 Template for Tables -->
<ng-template #infoTables let-data let-sub_title="sub_title" let-key="key" let-loadingKey="loadingKey"
  let-isFlexCol="isFlexCol">
  <div class="p-4">
    <button hidden class="p-1 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition float-right"
      [attr.title]="'More info about ' + sub_title">
      <app-icon [name]="'sparkles'" [size]="24"
        [class]="'w-6 h-6 text-slate-700 dark:text-slate-300 cursor-pointer float-right'" />
    </button>
    <div class="mb-4">
      <span class="text-xl font-medium text-[#141437] dark:text-white font-['Inter',sans-serif]">{{ sub_title
        }}</span>
    </div>
    <div class="overflow-hidden h-[400px]">
      <app-scroll-table [showTableWithBorderAndRadius]="true" [tableData]="data" [showHeaderIcon]="true"
        [previousData]="[]" [headers]="createTableHeaders(data)" [tableKey]="key" [showHeading]="false"
        [isColFlex]="isFlexCol">
      </app-scroll-table>
      @if(loadingKey && isSectionLoading(loadingKey)){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
  </div>
</ng-template>

<!-- 🔹 Template for Graph -->
<ng-template #infoGraph let-data let-sub_title="sub_title" let-showToggleButton="showToggleButton"
  let-chartKey="chartKey" let-loadingKey="loadingKey" let-showCircleStrokes="showCircleStrokes"
  let-showCircleStrokesWithStroke="showCircleStrokesWithStroke" let-height="height" let-showXGridLines="showXGridLines"
  let-showYGridLines="showYGridLines">
  <div class="p-4 h-full">

    <div class="mb-4 flex items-center justify-between">
      <span class="text-lg font-medium text-[#141437] dark:text-white font-['Inter',sans-serif] max-w-[360px]">
        {{ sub_title }}
      </span>
      @if(showToggleButton){
      <app-toggle-btns style="float: right;" [headerOptions]="{ 
          showlabels: true, 
          showIcon: true, 
          showToggleButton: true, 
          toggleOptions: tabOptions
        }" (viewChanged)="setActiveTab($event, chartKey)">
      </app-toggle-btns>
      }
    </div>


    <div [ngStyle]="{ height: height + 'px' }" class="overflow-hidden">
      <div class="h-full">
        @if(getView(chartKey) == 'lineChart'){
        @if(data?.data1 || data?.data2 || data?.data3 || data?.data4){
        <app-line-chart [data1]="data?.data1 || []" [data2]="data?.data2 || []" [data3]="data?.data3 || []"
          [data4]="data?.data4 || []" valueKey="value" unit="month" [showYAxis]="true" [showYAxisGrid]="showYGridLines"
          [showYAxisPath]="true" curveType="curveLinear" [showCircleStrokes]="showCircleStrokes"
          [showCircleStrokesWithStroke]="showCircleStrokesWithStroke" [showAllXLabels]="false"
          [showXAxisGrid]="showXGridLines" [unit]="unit()" [tooltipExtraData]="linetoolTipData">
        </app-line-chart>
        }
        }
        @if(getView(chartKey) == 'barChart'){
        @if(data?.data1.length > 0 || data?.data2.length > 0 || data?.data3.length > 0 || data?.data4.length > 0){
        <div class="chart-wrapper w-full h-full">
          <app-multiple-bar [data1]="data?.data1 || []" [data2]="data?.data2 || []" [data3]="data?.data3 || []"
            [data4]="data?.data4 || []" [valueKey]="'value'" [addGradient]="false" [barTextposition]="'top'"
            [barClusterPixel]="14" [tooltipData]="toolTipData" [showTooltipLabel]="false" [showDynamicxAxisLabel]="true"
            [darkBarOutlineFill]="'#252558ba'" [lightBarOutlineFill]="'#F5F5F5'" [barClusterHeight]="80"
            [colors]="colors" [xAxisShowOnlyFirstLast]="true" [showAllXticks]="false" [autoScrollOn5Years]="true"
            [valueType]="'number'">
          </app-multiple-bar>
        </div>
        }

        }
      </div>
    </div>
    @if(loadingKey && isSectionLoading(loadingKey)){
    <app-individual-toaster></app-individual-toaster>
    }

  </div>
</ng-template>


<!-- 🔹 Template for Stats Cards -->
<ng-template #cardTemplate let-data let-colSpan="colSpan">
  <div
    class="card-classes rounded-2xl flex flex-col items-center text-center space-y-2 hover:shadow-xl transition-shadow duration-300"
    [ngClass]="'col-span-' + colSpan">

    <div class="p-2 rounded-lg" [ngClass]="data.bgClass">
      <app-icon [name]="data.icon" [size]="20" [class]="'h-5 w-5 ' + data.iconClass" />
    </div>

    <h4 class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{{ data.label }}</h4>
    <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ data.value }}</p>
  </div>
</ng-template>



<!-- <div class="overflow-hidden rounded-lg border border-slate-200 dark:border-slate-700">
      <div class="overflow-x-auto">
        <table class="w-full border-collapse bg-white dark:bg-slate-800">
          <thead class="table w-full bg-gray-50 dark:bg-slate-700 sticky top-0 z-10" style="table-layout: fixed;">
            <tr>
              <th *ngFor="let key of getKeys(data[0])" (click)="sortData(data, key, sub_title)"
                class="bg-blue-600 dark:bg-blue-700 hover:bg-blue-500 transition text-white font-['Inter',sans-serif] font-semibold text-xs uppercase px-3 py-2 text-left cursor-pointer select-none">
                <div class="flex items-center justify-between">
                  <span>{{ key }}</span>
                  <span *ngIf="sortState[sub_title]?.key === key">
                    <svg *ngIf="sortState[sub_title]?.order === 'asc'" xmlns="http://www.w3.org/2000/svg"
                      class="w-3 h-3 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                    </svg>
                    <svg *ngIf="sortState[sub_title]?.order === 'desc'" xmlns="http://www.w3.org/2000/svg"
                      class="w-3 h-3 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="block w-full overflow-y-auto" style="max-height: 300px;">
            <tr *ngFor="let row of data"
              class="table w-full bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
              style="table-layout: fixed;">
              <td *ngFor="let key of getKeys(row)"
                class="px-3 py-2 align-middle text-sm text-slate-900 dark:text-slate-100">
                {{ row[key] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->